import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, } from 'react';
import { IconButton } from '../IconButton/index';
import { ActionPanelTransition } from './ActionPanelTransition';
import { transitionSides } from './constants';
import { closeButtonStyles } from './styles';
const defaultProps = {
    className: '',
    show: false,
    transition: {
        side: transitionSides.left,
    },
};
const ActionPanel = ({ children, className = defaultProps.className, onCloseClick, show = defaultProps.show, transition = defaultProps.transition, }) => (_jsx("div", Object.assign({ css: css `overflow: hidden;` }, { children: _jsx(ActionPanelTransition, Object.assign({ actionPanelClassName: className, fade: Boolean(transition.fade), show: show, side: transition.side }, { children: _jsxs("div", Object.assign({ onClick: (event) => {
                event.stopPropagation();
            }, role: "presentation" }, { children: [_jsx("div", Object.assign({ css: closeButtonStyles }, { children: _jsx(IconButton, { iconType: "close", onClick: onCloseClick, size: "medium", type: "secondary" }) })), children] })) })) })));
const MemoizedActionPanel = memo(ActionPanel);
export { MemoizedActionPanel as ActionPanel };
// MC-1068 Temporary hack for Storybook.
export default ActionPanel;
